// modalSlice.ts
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
  isOpen: boolean;
  quickActionOpen: boolean;
  quickActionsList: string[];
  quickActionModal: number;
  beneficiaryModalOpen: boolean;
  beneficiaryType: string;
  paymentType: string;
  newPaymentOpen: boolean;
  newPaymentList: string[];
  newPaymentModal: any;
  manageBeneficiaryModalOpen: boolean;
  initiateTransferModalOpen: boolean;
  selectedBeneficiary: any;
  aaniTransferOpen: boolean;
  domesticTransferOpen: boolean;
}

const initialState: ModalState = {
  isOpen: false,
  quickActionOpen: false,
  quickActionsList: [],
  quickActionModal: 1,
  beneficiaryModalOpen: false,
  beneficiaryType: "",
  paymentType: "",
  newPaymentOpen: false,
  newPaymentList: [],
  newPaymentModal: 1,
  manageBeneficiaryModalOpen: false,
  initiateTransferModalOpen: false,
  selectedBeneficiary: null,
  aaniTransferOpen: false,
  domesticTransferOpen: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },

    openQuickAction: (state) => {
      state.quickActionOpen = true;
    },
    closeQuickAction: (state) => {
      state.quickActionOpen = false;
    },

    OpenBeneficiaryModal: (state) => {
      state.beneficiaryModalOpen = true;
    },
    CloseBeneficiaryModal: (state) => {
      state.beneficiaryModalOpen = false;
    },

    OpenManageBeneficiaryModal: (state) => {
      state.manageBeneficiaryModalOpen = true;
    },

    OpenInitiateTransferModal: (state) => {
      state.initiateTransferModalOpen = true;
    },
    CloseInitiateTransferModal: (state) => {
      state.initiateTransferModalOpen = false;
    },

    setQuickActionModal: (state, action: PayloadAction<number>) => {
      state.quickActionModal = action.payload;
    },

    setQuickActionsList: (state, action: PayloadAction<string[]>) => {
      state.quickActionsList = action.payload;
    },

    setBeneficiaryType: (state, action: PayloadAction<string>) => {
      state.beneficiaryType = action.payload;
    },
    setPaymentType: (state, action: PayloadAction<string>) => {
      state.paymentType = action.payload;
    },

    openNewPayment: (state) => {
      state.newPaymentOpen = true;
    },
    closeNewPayment: (state) => {
      state.newPaymentOpen = false;
    },

    setNewPaymentModal: (state, action: PayloadAction<string>) => {
      state.newPaymentModal = action.payload;
    },
    setNewPaymentList: (state, action: PayloadAction<string[]>) => {
      state.newPaymentList = action.payload;
    },

    SelectedBeneficiary: (state, action: PayloadAction<any>) => {
      state.selectedBeneficiary = action.payload;
    },

    openAaniTransferModal: (state) => {
      state.aaniTransferOpen = true;
    },
    closeAaniTransferModal: (state) => {
      state.aaniTransferOpen = false;
    },
  },
});

export const {
  openModal,
  closeModal,
  openQuickAction,
  closeQuickAction,
  setQuickActionModal,
  setQuickActionsList,
  openNewPayment,
  closeNewPayment,
  setNewPaymentModal,
  setNewPaymentList,
  setBeneficiaryType,
  setPaymentType,
  OpenBeneficiaryModal,
  CloseBeneficiaryModal,
  OpenManageBeneficiaryModal,
  OpenInitiateTransferModal,
  CloseInitiateTransferModal,
  SelectedBeneficiary,
  openAaniTransferModal,
  closeAaniTransferModal,
} = modalSlice.actions;

export default modalSlice.reducer;
